/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load LinkedIn event listeners
 *
 * https://www.linkedin.com/help/lms/answer/a425606?lang=en-US
 *
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.linkedin?.partner_id && !pmwDataLayer?.pixels?.linkedin?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "LinkedIn")) pmw.load_linkedin_pixel()
	}
})

// view_content event
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: view_content event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: add_to_cart event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})


// View order received page event
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: purchase event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

